/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useMemo, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { AutoCompleteVerbas, IVFormErrors, useVForm, VFieldMoney, VForm } from '../../../shared/forms';
import * as yup from 'yup';
import { v4 as uuidv4 } from 'uuid';
import { VerbaService } from '../../../shared/services/api/rh/verbas/VerbaService';

interface IFormData {
  idfolha: string;
  idverbo: string;
  idverbas: string;
  descricao: string;
  qtd: number;
  vencimentos: number;
  descontos: number;
  id: number;
}

export interface ConfirmationDialogRawProps {
  id: string;
  idfolha: string;
  value: string;
  open: boolean;
  dados?: IFormData;
  onDados: (dados: IFormData) => void;
  onClose: (value?: string) => void;
}

const formValidationSchema: yup.ObjectSchema<Omit<IFormData, 'idverbo'>> = yup.object().shape({
  idfolha: yup.string().required(),
  idverbas: yup.string().required(),
  descricao: yup.string().required(),
  qtd: yup.number().required(),
  vencimentos: yup.number().required(),
  descontos: yup.number().required(),
  id: yup.number().optional().default(0),
});

export const DialogFolha: React.FC<ConfirmationDialogRawProps> = (props: ConfirmationDialogRawProps) => {
  const {formRef, save, } = useVForm();
  const { onClose, value: valueProp, open, ...other } = props;
  const [value, setValue] = useState(valueProp);
  const [isLoading, setIsLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [descricao, setDescricao] = useState<string>();
  const [id, setId] = useState('');
  const [tipovencimento, setTipoVencimento] = useState(true); 
  const [tipodesconto, setTipoDesconto] = useState(true); 
  const [idverba, setIdVerba] = useState(0);
  const [isstatus, setIsStatus] = useState(false);
  
  const guuid = uuidv4();

  const itensnovo  = {
    qtd: 0,
    vencimentos: 0,
    descontos: 0,
  };

  useEffect(() => {
    if(props.id === 'novo'){
      formRef.current?.setData(itensnovo);
      setIsStatus(false);
    }else{
      if (props.dados && typeof props.dados === 'object') {
        formRef.current?.setData(props.dados); 
        handleuuidVerbas(props.dados.idverbas);
        setIsStatus(true);
      }
    }
  }, [id, formRef]);  

  const handleCancel = () => {
    onClose();
  };

  const handleuuidVerbas = (uuid: string | undefined) => {
    VerbaService.getById(uuid!)
      .then((result) => {
        setIsLoading(false);
        if (result instanceof Error) {
          alert(result.message);
        } else {
          setDescricao(result.descricao);
          setTipoVencimento(result.tipoverba === 'vencimento' ? false : true );
          setTipoDesconto(result.tipoverba === 'desconto' ? false : true );
          setIdVerba(result.id);
        }
      });
  };

  useEffect(() => {
    if (!open) {
      setValue(valueProp);
    }else{
      setId(valueProp);
    }
  }, [valueProp, open]);
  
  const handleSave = (dados: IFormData) => {
    setIsLoading(true);  
    dados.idfolha=props.idfolha;
    dados.descricao=descricao || '';
    dados.id=idverba;
    formValidationSchema.
      validate(dados, { abortEarly: false })
      .then((dadosValidados) => {
        setIsLoading(true);
        if(props.id === 'novo'){
          props.onDados({idverbo: guuid, ...dadosValidados});
          onClose(value);
          setIsLoading(false);
        }else{
          props.onDados({idverbo: props.dados?.idverbo || '', ...dadosValidados});
          onClose(value);
          setIsLoading(false);
        }
      })
      .catch((errors: yup.ValidationError) => {
        const validationErrors: IVFormErrors = {};   
        errors.inner.forEach(error => {
          if (!error.path) return;
          validationErrors[error.path] = error.message;
        });
        formRef.current?.setErrors(validationErrors);
      });
  };

  return (
    <Dialog
      open={open}
      {...other}      
    >
      <DialogTitle>Folha de Pagamento</DialogTitle>
      <DialogContent dividers>
        <VForm ref={formRef}  onSubmit={handleSave}>
          <Grid container direction="column" padding={1}>
            <Grid container item direction="row" padding={1} spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                <Grid container item direction="row" spacing={1} >
                  <Grid item xs={12} sm={12} md={9} lg={12} xl={12}>
                    <AutoCompleteVerbas
                      isExternalLoading={isstatus}
                      idverbas={handleuuidVerbas}
                    /> 
                  </Grid> 
                  <Grid item xs={12} sm={12} md={2} lg={4} xl={4}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='qtd'
                      label='Quantidade'
                    />
                  </Grid>   
                  <Grid item xs={12} sm={12} md={3} lg={4} xl={4}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='vencimentos'
                      label='Vencimentos'
                      disabled={tipovencimento}
                    />
                  </Grid>    
                  <Grid item xs={12} sm={12} md={3} lg={4} xl={4}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='descontos'
                      label='Descontos'
                      disabled={tipodesconto}
                    />
                  </Grid>             
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </VForm>
      </DialogContent>
      <DialogActions>
        <Button size='small' variant='outlined' onClick={handleCancel}>Voltar</Button>      
        <Button size='small' variant='outlined' autoFocus onClick={save}>Salvar</Button>
      </DialogActions>
    </Dialog>
    
  );
}; 